var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-row",
    { attrs: { dense: "" } },
    [
      _c(
        "v-col",
        { attrs: { cols: "12" } },
        [
          _c("AAQuickLook", {
            attrs: {
              "case-outputs": _vm.caseOutputs,
              "input-case": _vm.inputCase,
              horizontal: true,
            },
          }),
        ],
        1
      ),
      _vm.displayDivider ? _c("v-divider", { attrs: { inset: "" } }) : _vm._e(),
      _c(
        "v-col",
        { attrs: { cols: "12" } },
        [
          _c("AADashboard", {
            attrs: {
              "case-outputs": _vm.caseOutputs,
              "input-case": _vm.inputCase,
              logoUrl: _vm.logoUrl,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }